module.exports = __webpack_public_path__ + "img/obs_dam_notset.0367cc78.svg";